import { call, put, takeEvery } from "redux-saga/effects";
import config from "../../../config/index";
import fetchService from "../../../lib/fetchService";
import { SYNC_MODELS_REQUEST, syncModelsError, syncModelsSuccess } from "./action";
import { handleSagaError } from "../../../dataproviders/errorResponseHandler";
import resources from "../../../config/resources";

const requestSaga = function*() {
  const url = `${config.urls.BACKEND}/v2/${resources.MODELS}/sync`;

  try {
    const response = yield call(fetchService.post, url);

    for (const action of yield call(handleSagaError, response, syncModelsError)) {
      yield put(action);
      return;
    }

    if (response.ok) {
      const responseData = yield call(() => response.json());
      yield put(syncModelsSuccess(responseData));
    } else {
      const statusCode = response.status;
      yield put(syncModelsError(new Error(`Request failed with error ${statusCode}!`)));
    }
  } catch (e) {
    yield put(syncModelsError(e));
  }
};

export default function*() {
  yield takeEvery(SYNC_MODELS_REQUEST, requestSaga);
}
